import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import affyn from '../../assets/images/virtualstart/affyn.jpg';
import kilma from '../../assets/images/virtualstart/kilmadao.jpg';
import fit from '../../assets/images/virtualstart/fitburn.jpg';
import {FaRegHourglass} from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";

import './virtualstart_styles/virtualprogress.css';

export default function VirtualProgress() {

    const navigate = useNavigate();

  return (
    <>
      <Container className='virtual_progress'>
        <Row>
          <Col>
            <h2>In Progress(3)</h2>
          </Col>  
        </Row>
        {/* Card 1 */}
        <Row>
          <div className='card progress_card rounded d-flex flex-row align-items-center'
          onClick={()=>navigate("/virtualstart/furthur")}>
              <Col lg={3} className='col-12'>
                <div className="prog_card_img">
                  <img src={affyn} alt="Card one Affyn" className='img-fluid rounded' />  
                </div>
              </Col>
              <Col lg={7} className='px-lg-3 col-12'>
                <div className="prog_mid_col_intro d-flex gap-3">
                  <h3>Affyn</h3>
                  <div className="prog_mid_col_intro_btn d-flex gap-3 mb-1 mt-1">
                    <Button>NONINITIAL</Button>
                    <Button>Airdrop</Button>
                  </div>
                </div>
                <div className="prog_mid_col_content">
                  <span>Affyn is a singapore based company, using blockchain-powered technology to develop
                    mobile games with...
                  </span>
                </div>
                <div className="card_mid_lower_content d-flex justify-content-between mt-1">
                    <p className='p-0 m-0'>0/100000 USDT</p>
                    <span>0.00% raised</span>
                </div>
                <div className="card_mid_lower_bar">
                    <div className="lower_bar_in"></div>
                </div>
              </Col>  
              <Col lg={2} className='col-12'>
              <div className="card_lower w-lg-25 fw-bold mt-3 mb-3">
                <div className='d-flex justify-content-end'>
                  <div className="card_lower_upcom d-flex gap-2 align-items-center rounded">
                    <FaRegHourglass />
                    <span>Upcoming</span>
                  </div>
                </div>
                <div className="card_lower_timer d-flex justify-content-between mt-5">
                  <p>Start in:</p>
                  <p>00 days 22:16:27</p>
                </div>
                <Button className='w-100 fw-bold'>Place Order</Button>
              </div>
              </Col>
            </div>
        </Row>
        {/* Card 2 */}
        <Row className='mt-3'>
          <div className='card progress_card rounded d-flex flex-row align-items-center'
          onClick={()=>navigate("/virtualstart/furthur")}>
              <Col lg={3} className='col-12'>
                <div className="prog_card_img">
                  <img src={kilma} alt="Card Kilma" className='img-fluid rounded' />  
                </div>
              </Col>
              <Col lg={7} className='px-lg-3 col-12'>
                <div className="prog_mid_col_intro d-flex gap-3">
                  <h3>KilmaDAO</h3>
                  <div className="prog_mid_col_intro_btn d-flex gap-3 mb-1 mt-1">
                    <Button>NONINITIAL</Button>
                    <Button>Airdrop</Button>
                  </div>
                </div>
                <div className="prog_mid_col_content">
                  <span>
                    KlimaDAO's objective is to scale the impact and efficiency of
                    climate finance globally through build...
                  </span>
                </div>
                <div className="card_mid_lower_content d-flex justify-content-between mt-1">
                    <p className='p-0 m-0'>0/30000 USDT</p>
                    <span>0.00% raised</span>
                </div>
                <div className="card_mid_lower_bar">
                    <div className="lower_bar_in"></div>
                </div>
              </Col>  
              <Col lg={2} className='col-12'>
              <div className="card_lower w-lg-25 fw-bold mt-3 mb-3">
                <div className='d-flex justify-content-end'>
                  <div className="card_lower_upcom d-flex gap-2 align-items-center rounded">
                    <FaRegHourglass />
                    <span>Upcoming</span>
                  </div>
                </div>
                <div className="card_lower_timer d-flex justify-content-between mt-5">
                  <p>Start in:</p>
                  <p>00 days 22:16:27</p>
                </div>
                <Button className='w-100 fw-bold'>Place Order</Button>
              </div>
              </Col>
            </div>
        </Row>
        {/* Card 3 */}
        <Row className='mt-3'>
          <div className='card progress_card rounded d-flex flex-row align-items-center'
          onClick={()=>navigate("/virtualstart/furthur")}>
              <Col lg={3} className='col-12'>
                <div className="prog_card_img">
                  <img src={fit} alt="Card Fit" className='img-fluid rounded' />  
                </div>
              </Col>
              <Col lg={7} className='px-lg-3 col-12'>
                <div className="prog_mid_col_intro d-flex gap-3">
                  <h3>FITBURN</h3>
                  <div className="prog_mid_col_intro_btn d-flex gap-3 mb-1 mt-1">
                    <Button>NONINITIAL</Button>
                    <Button>Airdrop</Button>
                  </div>
                </div>
                <div className="prog_mid_col_content">
                  <span>
                   World's First AI-Powered Burn-to-Earn Fitness App!
                   Revolutionizing Lifestyle & Health. Fitburn is...
                  </span>
                </div>
                <div className="card_mid_lower_content d-flex justify-content-between mt-1">
                    <p className='p-0 m-0'>0/30000 USDT</p>
                    <span>0.00% raised</span>
                </div>
                <div className="card_mid_lower_bar">
                    <div className="lower_bar_in"></div>
                </div>
              </Col>  
              <Col lg={2} className='col-12'>
              <div className="card_lower w-lg-25 fw-bold mt-3 mb-3">
                <div className='d-flex justify-content-end'>
                  <div className="card_lower_upcom d-flex gap-2 align-items-center rounded">
                    <FaRegHourglass />
                    <span>Upcoming</span>
                  </div>
                </div>
                <div className="card_lower_timer d-flex justify-content-between mt-5">
                  <p>Start in:</p>
                  <p>00 days 22:16:27</p>
                </div>
                <Button className='w-100 fw-bold'>Place Order</Button>
              </div>
              </Col>
            </div>
        </Row>
      </Container>
    </>
  )
}
